import {
    GroupFormItem,
    IFormItemElement,
    IGroupFormItemProps
} from "../model/FormModel";
import ErrorWrapperFE from "../form-element/ErrorWrapperFE";
import React, {DetailedHTMLProps, InputHTMLAttributes} from "react";

interface IProps extends IFormItemElement
{
    formItemProps:IGroupFormItemProps;
    elementProps?: DetailedHTMLProps<InputHTMLAttributes<HTMLFieldSetElement>, HTMLFieldSetElement>
}
const GroupItemFIE = (props: IProps) =>
{
    let {
        form,
        label,
        instructions,
        formItemProps,
        elementProps,
        children,
    } = props;

    const formItem = form.requireFormItem(formItemProps, "group", true) as GroupFormItem;
    label = label ?? formItem.name;
    label = label || !formItem.required ? label : " ";

    return <div className={form.isFormItemHidden(formItem) ? "d-none" : ""}>
        <ErrorWrapperFE
            formItem={formItem}
        >
            <fieldset
                data-form-item-id={formItem.itemID}
                {...elementProps}
            >
                <div className="row">
                    {!!label &&
                        <div className="col-12">

                            <label
                                className={"form-item-label" + (formItem.required ? " required" : "")}
                            >
                                {label}
                                <input id={formItem.itemID} className="d-none" />
                            </label>
                        </div>
                    }
                    {!!instructions && (
                        <div className="col-12">
                            <span className="instructions">{instructions}</span>
                        </div>
                    )}
                    <div className="col-12">
                        {children}
                    </div>
                </div>

            </fieldset>
        </ErrorWrapperFE>
    </div>;
}

export default GroupItemFIE;